import store from '@/states/index.js'

import SupplierQuoted from '../SupplierQuoted.vue'

export default [
    {
        path: '/supplier_quoted',
        component: SupplierQuoted,
        name: 'supplier_quoted',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 2){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]